<template>
  <div class="box">
    <div class="columns is-multiline">
      <profile-menu></profile-menu>
      <profile-page :profile-data="profile_data" v-show="page_section === 'profile'"></profile-page>
      <profile-update :profile-data="profile_data" v-show="page_section === 'profile_update'"></profile-update>
      <profile-change-password v-show="page_section === 'change_password'"></profile-change-password>
    </div>
  </div>
</template>

<script>
import ProfileMenu from './components/ProfileMenu'
import ProfilePage from './components/ProfilePage'
import ProfileUpdate from './components/ProfileUpdate'
import ProfileChangePassword from './components/ProfileChangePassword'

export default {
  data () {
    return {
      page_section: 'profile',
      profile_data: {}
    }
  },
  components: {
    ProfileMenu,
    ProfilePage,
    ProfileUpdate,
    ProfileChangePassword
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
    this.getProfile()
  },
  mounted () {
    this.$geb.getFilteredBus({id: 'profile_section_event'}).subscribe(eventData => {
      this.page_section = eventData.eventData
      if (this.page_section === 'profile' || this.page_section === 'profile_update') {
        this.getProfile()
      }
    })
  },
  methods: {
    getProfile () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGetSession('profile')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.profile_data = response.data.data
        } else {
          var result = response.data.message
          for (var name in response.data.message) {
            self.errors.remove(name)
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/profile/Home.vue